// extracted by mini-css-extract-plugin
export default {"apple-pay-button":"VPfd0w","applePayButton":"VPfd0w","rect":"aVJi2h","pill":"rblRsF","black":"dTbBKz","white":"_FuhG6"};